import { Injectable } from "@angular/core";
import { Observable, of ,throwError } from "rxjs";
import { catchError, tap} from 'rxjs/operators';
import { UnsubModel } from "./unsub.model";
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class UnsubService{
    apiUrl: string = 'http://localhost:3000/unsubs';
    //headers = new HttpHeaders().set('Content-Type', 'application/json');

    constructor(private http: HttpClient){};
    /*
    unsubs: UnsubModel[] = [new UnsubModel("Jack the Ripper","Terrorized London in the late 18th century."),
    new UnsubModel("Bob the killerr","LA killer that did nothing good.."),
    new UnsubModel("Foyer","Was a fictinonal caracter on the TV series Criminal Minds."),
    new UnsubModel("Unsub 2","Just aplace holder. Was a fictinonal caracter on the TV series Criminal Minds.")]

    public getUnsubs(): UnsubModel[]{
       return  [new UnsubModel("Jack the Ripper","Terrorized London in the late 18th century."),
        new UnsubModel("Bob the killerr","LA killer that did nothing good.."),
        new UnsubModel("Foyer","Was a fictinonal caracter on the TV series Criminal Minds."),
        new UnsubModel("Unsub 2","Just aplace holder. Was a fictinonal caracter on the TV series Criminal Minds.")
        ]
    }
    public getUnsubsAsync(): Observable<UnsubModel[]>{
        const unsub = of(this.unsubs);
        return unsub;
    }
    */

    public getUnsubsNetwork(): Observable<UnsubModel[]> {
        return this.http.get<UnsubModel[]>(this.apiUrl).pipe(
            tap(data => console.log(JSON.stringify(data))),
            catchError(this.errorHandler)
        );
    }
    public getUnsub(id:Number): Observable<UnsubModel[]> {
        return this.http.get<UnsubModel[]>(this.apiUrl + "/" +id).pipe(
            tap(data => console.log(JSON.stringify(data))),
            catchError(this.errorHandler)
        );
    }
    public addUnsub(unsub:UnsubModel): Observable<UnsubModel[]> {
            return this.http.post<UnsubModel[]>(this.apiUrl,unsub).pipe(
                tap(data => console.log(JSON.stringify(data))),
                catchError(this.errorHandler)
            );
    }
    public deleteUnsub(id:Number): Observable<UnsubModel[]> {
        return this.http.delete<UnsubModel[]>(this.apiUrl+"/"+id).pipe(
            tap(data => console.log(JSON.stringify(data))),
            catchError(this.errorHandler)
        );
}


    private errorHandler(err: HttpErrorResponse) {
        //TODO, add error handling.
        // err.status //500 or something
        // err.statusText // Internal server error(maps to code?)
        // err.error //object returned from service that includes error and err
            // err.error.error // customer error message
            // err.error.err complete error from nodejs
        console.log("Error occurred");
        console.log(err);
        return throwError("Error message");
    }

}